var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNoMusic(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Iconex/Broken/Music"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Music"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 33",
    cx: 3.40278,
    cy: 3.40278,
    r: 3.40278,
    transform: "matrix(-1 0 0 1 12.918 21.7637)",
    stroke: "#D0D0D0",
    strokeWidth: 2.33333
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line",
    d: "M12.918 7.47222V16.3194V18.5312",
    stroke: "#D0D0D0",
    strokeWidth: 2.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_2",
    d: "M27.8906 4.74989V22.4443",
    stroke: "#D0D0D0",
    strokeWidth: 2.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_3",
    d: "M27.8902 4.75043L12.918 7.47266",
    stroke: "#D0D0D0",
    strokeWidth: 2.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_4",
    d: "M12.918 12.916L20.4041 11.5549L24.1471 10.8743",
    stroke: "#D0D0D0",
    strokeWidth: 2.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 33_2",
    cx: 3.40278,
    cy: 3.40278,
    r: 3.40278,
    transform: "matrix(-1 0 0 1 27.8906 19.7227)",
    stroke: "#D0D0D0",
    strokeWidth: 2.33333
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoMusic);
export default __webpack_public_path__ + "static/media/noMusic.c91b5cf31cbf6deaefc2729fe7a217bd.svg";
export { ForwardRef as ReactComponent };